import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function changeStateUsers (data) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getLocations
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/usuarios/activarDesactivarUsuario',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { changeStateUsers }
